import React, { useState, useRef } from "react";
import styled from "styled-components";
import { useLanguage } from "../../LangTranslation/LanguageContext";
import FormikSelect from "../../Formik/FormikSelect";
import FormikInput from "../../Formik/FormikInput";
import { TABLE_CELL_INPUT_MINIMUM_WIDTH } from "../../../utilities/constants";
import SVGButton from "../../Buttons/SVGButton";
import deleteIcon from "../../../Images/Delete.svg";
import useListOptions from "../../../CustomHooks/useListOptions";
import { findAndAddOption } from "../../../utilities/findAndAddOption";
import { useFormikContext } from "formik";
import useConfirmationModal from "../../ConfirmationModal/useConfirmationModal";
import { useSession } from "../../../authentications/SessionContext";
import { primaryColor } from "../../../utilities/colors";
import { enqueueSnackbar } from "notistack";
import { checkBase64Type } from "../../../utilities/checkFileType";
import { fileToBase64 } from "../../../utilities/fileToBase64";
import { getToken } from "../../../authentications/getCSRFToken";
import { getWebContent } from "../../../DataApi/Company/getWebContent";
import { callButtonGeneral } from "../../../DataApi/generalApis/callButtonGeneral";

const TableContainer = styled.div`
  width: 100%;
  background-color: #fff;
  border-radius: 15px;
  // padding: 20px;
  overflow: auto;
  .table tbody tr td,
  .table thead tr {
    padding: 21px !important;
    font-family: "Inter", sans-serif;
    border-bottom: 0px !important;
    font-weight: 600;
  }

  .table th {
    background-color: #f8f9fa !important;
    padding: 15px !important;
    color: #4e5d78 !important;
    font-family: "Inter", sans-serif;
    font-size: 14px;
  }

  tbody tr:hover {
    background-color: #f4f8ff;
  }
`;
const Button = styled.button`
  background-color: #fff;
  color: #ff5837;
  border: none;
  font-weight: 600;
  width: 130px;
  min-width: 150px;
  height: 40px;
  margin-right: 110px;
  outline: none; /* Remove default button outline */
`;

const ContactDetails = ({
  keyName,
  disabled,
  refetchData,
  //   bankList,
  form,
  name,
  push,
  replace,
}) => {
  // console.log(bankList, "bankList");
  const { language, translations } = useLanguage();
  const t = translations[language];
  const { sessionInfo } = useSession();
  const { isVTEX, context, company_id } = sessionInfo;
  const { values, setFieldValue } = form;
  const { associated_user_ids } = values;
  // console.log(associated_user_ids, "associated_user_ids");
  const {
    options: stateList,
    setOptions: setStateList,
    handleCustomSearch,
  } = useListOptions();
  const { ConfirmationModal, toggleModal, setMetaData, setTitle } =
    useConfirmationModal();

  const fileInputRef = useRef();
  const [loading, setLoading] = useState(false);

  const addRow = () => {
    push({
      attachment_id: false,
      contract_status: false,
      date_start: false,
      branch_name: false,
      id: false,
      isDeleted: false,
    });
  };
  const removeRow = (index) => {
    replace(index, { ...associated_user_ids[index], isDeleted: true });
  };

  return (
    <div>
      <ConfirmationModal />
      <TableContainer>
        <table className="table">
          <thead>
            <tr className="heading_row">
              <th
                className="text-center"
                style={{ minWidth: TABLE_CELL_INPUT_MINIMUM_WIDTH }}
              >
                {t["Name"]}
              </th>
              <th
                className="text-center"
                style={{ minWidth: TABLE_CELL_INPUT_MINIMUM_WIDTH }}
              >
                {t["Email"]}
              </th>
              <th
                className="text-center"
                style={{ minWidth: TABLE_CELL_INPUT_MINIMUM_WIDTH }}
              >
                {t["Phone"]}
              </th>
              <th
                className="text-center"
                style={{ minWidth: TABLE_CELL_INPUT_MINIMUM_WIDTH }}
              >
                {t["Designation"]}
              </th>
              <th className="text-center" style={{ minWidth: 50 }} />
            </tr>
          </thead>
          <tbody>
            {associated_user_ids
              .filter((user) => user.isDeleted === false)
              .map((user, index) => {
                return (
                  <tr key={index}>
                    <td className="align-middle">
                      <FormikInput
                        disabled={disabled}
                        name={`${name}.${index}.name`}
                        style={{ textAlign: "center" }}
                      />
                    </td>
                    <td className="align-middle">
                      <FormikInput
                        disabled={disabled}
                        name={`${name}.${index}.email`}
                        style={{ textAlign: "center" }}
                      />
                    </td>
                    <td className="align-middle">
                      <FormikInput
                        disabled={disabled}
                        name={`${name}.${index}.phone`}
                        style={{ textAlign: "center" }}
                      />
                    </td>
                    <td className="align-middle">
                      <FormikInput
                        disabled={disabled}
                        name={`${name}.${index}.designation`}
                        style={{ textAlign: "center" }}
                      />
                    </td>

                    <td className="align-middle">
                      {!disabled && (
                        <button
                          onClick={() => removeRow(index)}
                          className="text-danger btn btn-lg"
                          style={{ outline: "none" }}
                        >
                          <i className="bi bi-trash-fill"></i>
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            {associated_user_ids.filter((user) => user.isDeleted === false)
              ?.length === 0 && (
              <tr>
                <td colSpan={5} className="text-center">
                  No Data Available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </TableContainer>

      {!disabled && (
        <Button
          role="button"
          type="button"
          disabled={disabled}
          onClick={addRow}
          style={{ color: isVTEX ? primaryColor.primary : "#ff5837" }}
        >
          + Add a Contact
        </Button>
      )}
    </div>
  );
};

export default ContactDetails;
